export const FETCH_INTEGRATION_REGISTRY = 'FETCH_INTEGRATION_REGISTRY';
export const POST_INTEGRATION_REGISTRY = 'POST_INTEGRATION_REGISTRY';
